import {createReducer} from "typesafe-actions";
import {MOBILE_MODAL_COUPON} from "../actions";

export const mobileCouponModal = createReducer(false).handleAction(MOBILE_MODAL_COUPON, (state, action) => action.payload);